module.exports = __webpack_public_path__ + "img/srtoke-circle-minus.8d5daf.svg";